export default __webpack_public_path__ + "a7dcc9aaf28faa81edf8384590f291bd.svg";